import { useMemo, useRef } from 'react'
import { ChartOptions } from 'chart.js'
import styles from 'components/charts/Charts.module.scss'
import { Bar } from 'react-chartjs-2'
import { BillingCycleChartProps } from '../types'
import { getBillingCycleChartOptions } from './chartjs.config'

const PreviousBillingCycleChartMobile = ({ chartData, labels, setHoverDataPointIndex }: Omit<BillingCycleChartProps, 'minMaxData'>) => {
  // Reference
  const chartRef = useRef<never>(null)

  // Fetch options here to prevent layout bug due to useWindowSize hook
  const options = useMemo<ChartOptions<'bar'>>(
    () => getBillingCycleChartOptions({ labels, isMobile: true, handleHoverDataPoint: setHoverDataPointIndex }),
    [labels, setHoverDataPointIndex]
  )

  return (
    <div className={styles['chart-wrapper']}>
      <Bar options={options} data={chartData} className={styles.chart} ref={chartRef} />
    </div>
  )
}

export default PreviousBillingCycleChartMobile
